"use client";

import { motion } from "framer-motion";
import { NewsInterface } from "@/types/news";
import { NewsCard } from "@/components/ui/NewsCard";
import { useEffect, useState } from "react";
import { Slider } from "@/common/SliderCustom";
import { containerVariants, fadeInUp } from "@/lib/motion/motionPresets";

// Simplified animation variants


interface Props {
  news: NewsInterface[];
  industry: string;
}

export const NewsMotion: React.FC<Props> = ({ news, industry }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [windowSize, setWindowSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setIsMounted(true);
    
    // Handle window resize
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Initial size
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  if (!isMounted) return null;

  // Determine items per view based on screen size
  const itemsPerView = windowSize.width >= 768 ? 2 : 1;

  return (
    <section 
      className="relative py-16 sm:py-20 lg:py-28 overflow-hidden"
      style={{
        background: `linear-gradient(135deg, 
          var(--color-bg-secondary) 0%, 
          var(--color-bg) 30%, 
          var(--color-bg-accent) 70%,
          var(--color-bg) 100%
        )`
      }}
    >
      <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
        >
          {/* Header Section */}
          <motion.div 
            variants={fadeInUp}
            className="flex items-center space-x-3 mb-8"
          >
            <div className="w-2 h-6 bg-accent rounded-full"></div>
            <h2 className="title-gradient block text-lg sm:text-xl lg:text-2xl font-bold uppercase">
              KIẾN THỨC CƠ BẢN VÀ LỜI KHUYÊN TRONG NGÀNH
            </h2>
          </motion.div>

          {/* Slider Integration */}
          <motion.div variants={fadeInUp}>
            <Slider
              key="news-slider"
              items={news}
              renderItem={(newsItem) => (
                <NewsCard news={newsItem} />
              )}
              onItemClick={(newsItem, index) => {
                console.log(`News article clicked:`, newsItem.title);
              }}
              itemsPerView={itemsPerView}
              gap={4}
              showArrows={windowSize.width >= 768}
              showDots={true}
              autoPlay={false}
              className="w-full h-full"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};